import type { RoleKey, User, UserStatus } from './types';
import { useUsersStore } from '.';
import { useEffect } from 'react';
import { loadUsers } from './actions';
import { useApiWithAuth } from '@/hooks/api';
import { useAuth } from '@/hooks/auth';

export interface UserFilter {
  roles?: RoleKey[];
  status?: UserStatus;
}

export function useUsersList({ roles, status = 'active' }: UserFilter) {
  const store = useUsersStore();
  const { api, auth } = useApiWithAuth();
  let list =
    status === 'any'
      ? store.computed.usersList
      : store.computed[`${status}UsersList` as keyof typeof store.computed];
  if (roles?.length) {
    list = list.filter((item) => roles.find((role) => item.data[role]));
  }

  useEffect(() => {
    loadUsers(store, { api, auth, force: false });
  }, [store, api, auth]);

  return list;
}

export function useCurrentUser(): User | null {
  const auth = useAuth();
  if (!auth.authorized || !auth.userMetadata) {
    return null;
  }

  return auth.userMetadata as unknown as User;
}
